module.exports = __webpack_public_path__ + "img/f25.d2f2c5c8.jpg";